import { Icon } from '../../../../../shared/ui';
import cn from 'classnames';
import cls from './FileItemImg.module.css';
import React, { useState } from 'react';

interface IFIleItemProps {
    imgUrl: string;
    fileName: string;
}

export const FileItemImg = ({ imgUrl, fileName }: IFIleItemProps) => {
    const [imgLoaded, setImgLoaded] = useState(false);
    const [imgError, setImgError] = useState(false);
    return (
        <>
            {(!imgLoaded || imgError) && (
                <Icon iconName="fileItemPlaceholder" width={15.4} height={21} />
            )}

            {!imgError && (
                <img
                    src={imgUrl}
                    alt={fileName}
                    className={cn(cls.filePreview, {
                        [cls.hidden]: !imgLoaded,
                    })}
                    onLoad={() => setImgLoaded(true)}
                    onError={() => setImgError(true)}
                />
            )}
        </>
    );
};
